import React, { useContext } from 'react';
import { FaSave, FaCogs, FaFolder } from 'react-icons/fa';
import './study-management.css';
import { AppContext } from 'components/app/RemExprertProvider';

const StudyManagement = ({ 
  onSave, 
  onQuitToAudits, 
  onQuitToExtranet,
  className = "" 
}) => {
   const context = useContext(AppContext);
  return (
     (context.state.ApiUser === true) ? null : ( 
    <div className={`study-management ${className}`}>
      <div className="study-management-title">
        Gestion de l'étude
      </div>
      
      <div className="study-management-actions">        <button 
          className="study-management-btn save-btn"
          onClick={onSave}
          title="Sauvegarder l'étude"
        >
          <FaSave />
          <span>Sauvegarder l'étude</span>
        </button>
        
        <button 
          className="study-management-btn quit-btn"
          onClick={onQuitToAudits}
          title="Retour aux audits"
        >
          <FaCogs />
          <span>Retour aux audits</span>
        </button>
        
        <button 
          className="study-management-btn extranet-btn"
          onClick={onQuitToExtranet}
          title="Retour à l'extranet"
        >
          <FaFolder />
          <span>Retour  à l'accueil </span>
        </button>
      </div>
    </div>
  ));
};

export default StudyManagement;
